import React from 'react';

const Promo = () => (
    <div className="promoBanner">
        <div className="promoBanner__wrapper">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor.
        </div>
    </div>
);
export default Promo;



// WEBPACK FOOTER //
// ./src/components/Header/components/Promo.jsx